module.exports = __webpack_public_path__ + "public/adminIcons/cancel.svg?a9c7136d";